import React from 'react'
import Icon from 'components/Icon'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { useIntl } from 'react-intl'
import { buildRoutes } from 'routes'
import useUrl from 'useUrl'
import { useBrand } from 'contexts/BrandContext'

import { Helmet } from 'react-helmet'
import { renderToString } from 'react-dom/server'

export const MetaBreadcrumbs = () => {
  const { formatMessage, locale } = useIntl()
  const brand = useBrand()
  const routes = buildRoutes(formatMessage, { withBreadcrumbs: true })
  const breadcrumbs = useBreadcrumbs(routes)

  const itemListElement = breadcrumbs.map(({ breadcrumb, match }, position) => {
    return {
      '@type': 'ListItem',
      position: position,
      name: breadcrumb.props.children,
      item: useUrl(locale, match.pathname, true, false, brand),
    }
  })

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElement,
  }

  return (
    <Helmet encodeSpecialCharacters={false}>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

export default MetaBreadcrumbs
